import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage'; // Asumiremos que aún está aquí por ahora
import LoginPage from './pages/LoginPage'; // Importamos la nueva página
import Dashboard from './pages/Dashboard';
import ClinicalEncounterPage from './pages/ClinicalEncounterPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/atender/:appointmentId" element={<ProtectedRoute><ClinicalEncounterPage /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
